export default __webpack_public_path__ + "static/media/image_12.6aeb351f.jpg";